export default __webpack_public_path__ + "static/media/gussmann.3d754293.jpg";